import React from 'react';
import { Img, svgSprite } from '../../../hybrid/wrappers';
import css from './CartItemWidget.module.scss';

const CartItemWidget = ({ item }) => {
    return (
        <div className={css.cartItemWidgetImage}>
            {item?.product?.image !== null ? (
                <Img className={css.cartItemWidgetImageInner} src={item?.product?.image?.links?.thumb} alt='image' />
            ) : (
                svgSprite('plug-grid-image', {
                    width: '48px',
                    height: '48px'
                })
            )}
        </div>
    );
};
export default CartItemWidget;
